<script lang="ts">
  import DefiProtocolsImg from '$lib/assets/branding/9.png?enhanced'
  import ButaneImage from '$lib/components/ButaneImage.svelte'
  import Button from '$lib/components/shadcn/button/button.svelte'
  import ButtonArrowUpSvg from '../../components/SVGs/ButtonArrowUpSVG.svelte'
</script>

<section class="relative flex flex-col space-y-8 overflow-hidden sm-desktop:space-y-8">
  <h4
    class="w-[90vw] self-center text-center font-graphik text-[28px] md:text-[38px] sm-desktop:w-[1165px] sm-desktop:text-[64px]"
  >
    Cardano’s academic edge distinguishes it from other blockchains and provides unique advantages for DeFi protocols.
  </h4>

  <Button
    variant="ghost"
    href="https://files.butane.dev/yellow-paper.pdf"
    target="_blank"
    class="relative z-[1] flex h-[48px] w-[198px] justify-between self-center rounded-full border-2 border-[#272D37] bg-black px-1 uppercase shadow-sm shadow-[#939EB8] transition-all duration-300 hover:scale-[1.01] active:scale-[.99]"
  >
    <p class="ml-4 font-graphik">Read More</p>
    <Button variant="ghost" class="h-[40px] w-[64px] rounded-full bg-[#20232E]">
      <ButtonArrowUpSvg svgStyles="scale-[1.7]" />
    </Button>
  </Button>

  <ButaneImage
    width={2000}
    height={2000}
    src="9.png"
    alt="icon"
    class="enhanced-img relative top-[-110px] z-[0] rotate-[-45deg] scale-[1.6] self-center sm:size-[600px]"
  />
</section>
